import logger from '@/utils/logger'

// Global toast service for showing notifications
class ToastService {
  constructor() {
    this.toastManager = null
  }

  // Initialize with the toast manager instance
  init(toastManager) {
    this.toastManager = toastManager
  }

  // Show a success toast
  success(title, message = '', options = {}) {
    return this.show({
      type: 'success',
      title,
      message,
      ...options
    })
  }

  // Show an error toast
  error(title, message = '', options = {}) {
    return this.show({
      type: 'error',
      title,
      message,
      autoClose: false, // Errors should be manually dismissed
      ...options
    })
  }

  // Show an info toast
  // Supports both info(title, options) and info(title, message, options)
  info(title, messageOrOptions = '', options = {}) {
    // If second arg is an object, treat it as options
    if (typeof messageOrOptions === 'object' && messageOrOptions !== null) {
      return this.show({
        type: 'info',
        title,
        message: '',
        ...messageOrOptions
      })
    }
    return this.show({
      type: 'info',
      title,
      message: messageOrOptions,
      ...options
    })
  }

  // Show a warning toast
  warning(title, message = '', options = {}) {
    return this.show({
      type: 'warning',
      title,
      message,
      ...options
    })
  }

  // Show a cart-specific toast with actions
  cartSuccess(productName, options = {}) {
    return this.show({
      type: 'success',
      title: 'Added to Cart!',
      message: `${productName} has been added to your cart.`,
      showActions: true,
      duration: 6000, // Longer duration for cart actions
      ...options
    })
  }

  // Generic show method
  show(options) {
    if (!this.toastManager) {
      logger.warn('Toast manager not initialized')
      return null
    }
    
    return this.toastManager.addToast(options)
  }

  // Clear all toasts
  clear() {
    if (this.toastManager) {
      this.toastManager.clearAllToasts()
    }
  }
}

// Create and export singleton instance
export const toastService = new ToastService()

// Vue plugin for easy access
export default {
  install(Vue) {
    Vue.prototype.$toast = toastService
    Vue.$toast = toastService
  }
}
